import { getURLConfigForPath } from '@otovo/shared/components/Navigation/localizedSanityPaths';
import { logToSentry } from '@otovo/shared/lib/sentry';
import { Cloud$Market } from '@otovo/shared/types/cloudEnums';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import { Sanity$LinkRoute } from '@otovo/shared/types/sanityTypes';

function assertExhaustiveCheck(type: never, route: Sanity$LinkRoute) {
  logToSentry(`Unhandled route type: ${type}`, { route });
  return '';
}

export function routeToHref(
  route: Sanity$LinkRoute | undefined,
  market: Cloud$Market,
  locale: Otovo$Locale,
) {
  if (!route) {
    return '';
  }
  const type = route._type;

  function getLocalizedQuotePath() {
    return getURLConfigForPath('/get-a-quote', market, locale).localizedPath;
  }

  function getLocalizedPackagePath() {
    return getURLConfigForPath('/packages', market, locale).localizedPath;
  }

  function getLocalizedProductPath() {
    return getURLConfigForPath('/products', market, locale).localizedPath;
  }

  switch (type) {
    case 'quotePage':
      return `${getLocalizedQuotePath()}/`;
    case 'landingPage':
      return `/a/${route.slug.current}/`;
    case 'packagePage':
      return `${getLocalizedPackagePath()}/${route.slug.current}/`;
    case 'productPage':
      return `${getLocalizedProductPath()}/${route.slug.current}/`;
    default:
      return assertExhaustiveCheck(type, route);
  }
}
